/*
 * @Description:业绩管理
 * @Version: 1.0
 * @Date: 2019-12-10 20:43:54
 * @Autor: LIANGYU
 * @LastEditTime: 2020-04-02 21:20:54
 * @LastEditors: Please set LastEditors
 */
const homeRouter = [
  {
    path: "/home/personalCenter",
    component: () => import("@/views/personalCenter"),
    name: "personalCenter",
    meta: { name: "个人中心" }
  },
  {
    path: "/home/personalCenter/center",
    component: () => import("@/views/personalCenter/indexTwo"),
    name: "personalCenterCenter",
    meta: { name: "个人中心" }
  },
  {
    path: "/home/personalCenter/masterCertification",
    component: () => import("@/views/personalCenter/masterCertification"),
    name: "masterCertification",
    meta: { name: "工长认证" }
  },
  {
    path: "/home/personalCenter/Performance",
    component: () => import("@/views/personalCenter/Performance"),
    name: "Performance",
    meta: { name: "业绩管理" }
  },
  {
    path: "/home/personalCenter/PhotoAlbum",
    component: () => import("@/views/personalCenter/PhotoAlbum"),
    name: "PhotoAlbum",
    meta: { name: "个人相册" }
  },
  {
    path: "/home/personalCenter/TeamFormation",
    component: () => import("@/views/personalCenter/TeamFormation"),
    name: "TeamFormation",
    meta: { name: "队伍组建" }
  },
  {
    path: "/home/RecruitmentInformation/projectHire",
    component: () => import("@/views/RecruitmentInformation/projectHire"),
    name: "projectHire",
    meta: {
      keepAlive: true,
    }
  },
  {
    path: "/home/consultingservices",
    component: () => import("@/views/ConsultingServices"),
    name: "ConsultingServices"
  },
  {
    path: "/home/RecruitmentInformation/projectHire/details/:id",
    component: () =>
      import("@/views/RecruitmentInformation/projectHire/details"),
    name: "projectHireDetails"
  },
  {
    path: "/home/AboutUs",
    component: () => import("@/views/AboutUs"),
    name: "AboutUs"
  },
  {
    path: "/home/login",
    component: () => import("@/views/login"),
    name: "login"
  },
  {
    path: "/home/navigation",
    component: () => import("@/views/navigation"),
    name: "navigation",
    meta: { name: "导航中心" }
  },
  //业绩上传
  {
    path: "/home/personalCenter/Performance/results",
    component: () => import("@/views/personalCenter/Performance/results"),
    name: "results",
    meta: { name: "业绩上传" }
  }
];
export default homeRouter;



// WEBPACK FOOTER //
// ./src/router/modules/personalCenter.js